import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { fadeInOut } from '@nw/ui-core-shared/animations/animations';
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';
import { LanguageService } from '@nw/ui-core-shared/services/language.service';
import { Vehicle } from '../../shared/domain/vehicle';
import { SortQuery, VehicleFilter } from '../../shared/domain';
import { WatchlistApplicationState } from '../../store/watchlist-state';
import { WatchListActions } from '../../store/actions/WatchListActions';
import { VehicleSortService } from '../../shared/services/vehicle-sort.service';
import { VehicleFilterService } from '../../shared/services/vehicle-filter.service';
import { EnvironmentService } from '@nw/ui-core-shared/services';
import { ModalDirective } from 'ngx-bootstrap';
import { VehiclesService } from '../../shared/services/vehicles.service';
import { TranslateService } from '@ngx-translate/core';
import { WATCHLIST_INITIAL_STORE_DATA, WatchlistStoreData } from '../../store/watchlist-store-data';
import { AppUiActions } from '@nw/ui-core-shared/store/actions';
import { VehicleLiveblockAuctionService } from "../../shared/services/vehicle-liveblock-auction.service";
import { ExportPdfExcelService } from '@nw/ui-core-shared/services/export-pdf-excel.service';
import * as FileSaver from 'file-saver';

@Component({
    selector   : 'nw-vehicle-list',
    templateUrl: './vehicle-list.component.html',
    animations : [fadeInOut]
})
export class VehicleListComponent implements OnInit, OnDestroy {
    removeVehicleModal: ModalDirective;
    liveblockAuctionMobileViewModal: ModalDirective;
    @Input() vehicle: Vehicle;
    vehicles: Vehicle[];
    vehiclesDataState: WatchlistStoreData = WATCHLIST_INITIAL_STORE_DATA;
    sortOptionData$: Observable<Array<SortQuery>>;
    filterOptionData$: Observable<Array<VehicleFilter>>;
    screenSize = 'lg';
    classicRuntimeData: any;
    isRemoving = false;
    currentVehicle: any;
    frontCarImage;
    liveBlockSubscription: any;
    showAutobidMobileView$ = false;
    isWatchlistV1 = true;
    ifAnyFilterCategorySelected = false;
    userId: string;
    orgId: string;
    pageName = 'watchlist.';

    constructor(private store: Store<WatchlistApplicationState>,
                private vehicleLiveblockAuctionService: VehicleLiveblockAuctionService,
                private mainStoreService: MainStoreService,
                private watchListActions: WatchListActions,
                public vehicleSortService: VehicleSortService,
                private languageService: LanguageService,
                private vehicleFilterService: VehicleFilterService,
                private environmentService: EnvironmentService,
                private vehicleService: VehiclesService,
                private translateService: TranslateService,
                private appUiActions: AppUiActions,
                private exportPdfExcelService: ExportPdfExcelService,
                private router: Router) {

        this.store.select(state => state.watchlistStoreData)
            .subscribe(loadVehicleState => {
                this.vehiclesDataState = loadVehicleState;

                this.vehicles = loadVehicleState.vehicles;
                // hide the remove vehicle modal if it's open
                if (this.removeVehicleModal && this.removeVehicleModal.isShown) {
                    this.hideVehicleRemoveModal()
                }

                // hide the liveblock auction mobile view modal if it's open
                if (this.liveblockAuctionMobileViewModal && this.liveblockAuctionMobileViewModal.isShown) {
                   this.liveblockAuctionMobileViewModal.hide();
                }
            });

        mainStoreService.getStore().select(state => state).subscribe(appMainState => {
            this.classicRuntimeData = appMainState.appPrincipal.getClassicRuntimeData();
            this.screenSize = appMainState.appUiState.screenSize;
            this.userId = appMainState.appPrincipal.getUserId();
            this.orgId = appMainState.appPrincipal.currentSelectedOrgId || appMainState.appPrincipal.defaultOrganization.id;
        });

        this.initSortFilterData();
    }

    ngOnInit() {
        this.store.dispatch(this.watchListActions.loadWatchList());
        this.frontCarImage = `${this.environmentService.getEnvironment().utilPath.asset}/img/car-frontview-graphic.svg`;

        this.liveBlockSubscription = this.vehicleLiveblockAuctionService.getLiveblockAuctionMobieView()
            .subscribe(data => {
                this.currentVehicle = data.vehicle;
                this.showAutobidMobileView$ = data.showAutobidMobileView;
                this.liveblockAuctionMobileViewModal.show();
            });
    }


    private initSortFilterData() {
        this.filterOptionData$ = Observable.create((observer: any) => {
            this.store.select(state => state.watchlistStoreData).subscribe(loadVehicleState => {
                    if(loadVehicleState.aggregations) {
                        const aggregations = this.vehicleFilterService.getFilterOptionData(loadVehicleState.aggregations);
                        observer.next(aggregations);
                    }
                });
        });

        this.sortOptionData$ = Observable.create((observer: any) => {
            this.vehicleSortService.getSortOptionData().subscribe((resp) => {
                observer.next(resp);
            });
        });
    }

    trackEntryItems(index, item): number {
        return item.nwVehicleId;
    }

    doSort($event: SortQuery): void {
        this.vehicleSortService.doSort($event);
    }

    doFiltering($event): void {
        this.vehicleFilterService.doFiltering($event);
    }

    exportWatchList(exportType) {
        const sortQuery = this.vehicleSortService.getSortByQuery();
        this.exportPdfExcelService.submitExport(exportType, sortQuery).subscribe(res => {
            this.downLoadFile(res, exportType);
        }, err => {
            console.error(err);
        });
    }

    downLoadFile(data: any, type: string) {
        FileSaver.saveAs(data, this.pageName + type);
    }

    initLiveblockAuctionMobileViewModal(modal) {
        this.liveblockAuctionMobileViewModal = modal;
    }

    initVehicleRemoveModal(modal) {
        this.removeVehicleModal = modal;
    }

    showVehicleRemoveModal(event) {
        this.currentVehicle = event.vehicle;
        const element = event.element;
        this.removeVehicleModal.onEsc = () => {
            this.removeVehicleModal.hide();
            element.focus();
        };
        this.removeVehicleModal.show();
    }

    private hideVehicleRemoveModal() {
        this.isRemoving = false;
        this.removeVehicleModal.hide();
    }

    onVehicleRemove(vehicleId) {
        this.isRemoving = true;
        this.vehicleService.removeVehicle(vehicleId).subscribe(
            (vehId) => {
                this.store.dispatch(this.watchListActions.removeVehicleSuccess(vehId));

                // after vehicle remove, auto refresh watchlist
                this.store.dispatch(this.watchListActions.loadWatchList());
            },
            (error) => {
                // display error message
               const golbalError = {
                    'message': this.translateService
                        .instant('pageWatchList.vehicleRemoveModal.errorMsg')
                };
                this.mainStoreService.getStore().dispatch(this.appUiActions.showGlobalError(golbalError));
                this.hideVehicleRemoveModal();
            });
    }

    removeAllVehicle(evt) {
        if (evt) {
            this.vehicleService.removeAllVehicles().subscribe( (res) => {
                if (res) {
                    this.store.dispatch(this.watchListActions.loadWatchList());
                }
            }, (error) => {
                this.store.dispatch(this.watchListActions.loadWatchList());
                const globalError = {
                    'message': this.translateService
                        .instant('pageWatchList.vehicleRemoveModal.errorMsg2')
                };
                this.mainStoreService.getStore().dispatch(this.appUiActions.showGlobalError(globalError));
            });
        }
    }

    openMobileViewFilter() {
        this.vehicleFilterService.passEventToMobileSidebarToOpen();
    }

    ngOnDestroy() {
        this.liveBlockSubscription.unsubscribe();
    }

    clearAllCategories() {
        this.vehicleFilterService.passEventToSidebarClearAllCategories();
    }
    onAnyFilterCategorySelected(event) {
        this.ifAnyFilterCategorySelected = event;
    }

    enableRemoveAllBtn() {
        let vehicleArr = [];
        if (this.vehicles.length > 0) {
            vehicleArr = this.vehicles.filter( (vehicle) => {
                return vehicle.allowRemove === true
            })
        }
        return vehicleArr.length < 2;
    }
}

/* istanbul ignore next */








// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/vehicle-list/vehicle-list.component.ts